// extracted by mini-css-extract-plugin
export default {"groupedQuestionsTabNav":"styles__groupedQuestionsTabNav___X19tZ","container":"styles__container___R0V3u","tab":"styles__tab___LR2Aw","selected":"styles__selected____rjhz"};